module.exports = __webpack_public_path__ + "asset/image/gradient-9331.png";